"use client";

import { useSyncExternalStore } from "react";

// Demo auth store shared by the login page and the navbar.
// Persists the signed-in user in localStorage until the real auth API is
// wired; login()/logout() notify every subscribed component (and other tabs).

export type AuthUser = { firstName: string; email: string };

const STORAGE_KEY = "sf-auth-user";
const AUTH_EVENT = "sf-auth-change";

let cachedRaw: string | null = null;
let cachedUser: AuthUser | null = null;

function getSnapshot(): AuthUser | null {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (raw !== cachedRaw) {
    cachedRaw = raw;
    try {
      cachedUser = raw ? (JSON.parse(raw) as AuthUser) : null;
    } catch {
      cachedUser = null;
    }
  }
  return cachedUser;
}

function getServerSnapshot(): AuthUser | null {
  return null;
}

function subscribe(onChange: () => void) {
  window.addEventListener(AUTH_EVENT, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(AUTH_EVENT, onChange);
    window.removeEventListener("storage", onChange);
  };
}

export function login(email: string): AuthUser {
  const base = email.split("@")[0] || "";
  const firstName = base ? base.charAt(0).toUpperCase() + base.slice(1) : "Utilisateur";
  const user: AuthUser = { firstName, email };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event(AUTH_EVENT));
  return user;
}

export function logout() {
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function useAuthUser(): AuthUser | null {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
